import { useEffect, useRef, useState } from 'react';
import { eliminarDocumento, getDocumentoPorCabecera } from '../../services/empleado/empleadoDocumentoService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { visualizarDocumento } from '../../services/empleado/empleadoDocumentoService';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

const VerArchivosGen = ({ datosCabecera }) => {
    const [lstDocumentos, setLstDocumentos] = useState([]);
    const [visorVisible, setVisorVisible] = useState(false);
    const [visorContent, setVisorContent] = useState(null);
    const [visorTitle, setVisorTitle] = useState('');
    const [visorType, setVisorType] = useState(null);

    const [cargaLic, setCargaLic] = useState(false);
    const [refresco, setRefresco] = useState(false)

    const xToast = useRef()

    //console.log ('ingreso...: ', datosCabecera)

    useEffect(() => {
        const recuperaDocumentos = async () => {
            try {
                setCargaLic(true)
                const data = await getDocumentoPorCabecera(datosCabecera.id);
                //console.log ('RECUPRADOS...: ', data)
                setLstDocumentos(data);
            } catch (err) {
                console.err('ERROR: ', err.message);
            } finally {
                setCargaLic(false)
            }
        };
        recuperaDocumentos();
    }, [datosCabecera.id, refresco]);

    const hideVisor = () => {
        setVisorVisible(false);
        // Limpiamos memoria tras cerrar
        setTimeout(() => {
            if (visorContent) {
                URL.revokeObjectURL(visorContent);
                setVisorContent(null);
            }
        }, 300);
    };

    const deleteLicencia = async(data) => {
        if (!window.confirm(`¿Estás seguro de eliminar la licencia ${data.numero}?`)) return;
        
                try {
                    await eliminarDocumento(data.id);
                    //const data = await anulaDocumentoCab(rowData.id)
                    xToast.current.show({
                        severity: 'success',
                        summary: 'Eliminado',
                        detail: 'Licencia eliminada.'
                    });
        
                    // Actualización optimista o recarga
                    //setLicencias((prev) => prev.filter((item) => item.id !== rowData.id));
                    setRefresco (prev => !prev)
                } catch (error) {
                    console.error('Error eliminando licencia:', error);
                    xToast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'No se pudo eliminar.'
                    });
                }
    }

    const archivoBodyTemplate = (rowData) => {
        if (!rowData.id) return null;

        // Función expandida para detectar archivos que el navegador puede "abrir"
        const esVisualizable = () => {
            const nombre = (rowData.urlGraph || rowData.nombreArchivo || '').toLowerCase();
            // Incluimos imágenes y PDFs
            return /\.(jpeg|jpg|gif|png|webp|bmp|pdf)$/i.test(nombre);
        };

        return (
            <div className="flex gap-2 justify-content-center">
                {/* Ahora el botón "Ver" aparece para Imágenes Y para PDFs */}
                {esVisualizable() && (
                    <Button
                        icon="pi pi-eye"
                        className="p-button-rounded p-button-text p-button-info"
                        tooltip="Visualizar"
                        onClick={() => handleVerDocumento(rowData)}
                    />
                )}

                <Button
                    icon="pi pi-download"
                    className="p-button-rounded p-button-text p-button-success"
                    tooltip="Descargar"
                    onClick={() => handleDescargarDocumento(rowData)}
                />

                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-text p-button-danger"
                    tooltip="Borrar"
                    onClick={() => deleteLicencia(rowData)}
                />
            </div>
        );
    };

    const handleVerDocumento = async (rowData) => {
        try {
            // 1. Obtenemos el archivo
            const blob = await visualizarDocumento(rowData.id);
            if (!blob) {
                alert('El archivo no tiene contenido.');
                return;
            }

            // 2. Detectamos tipo y nombre
            let tipoArchivo = blob.type;
            const nombreOriginal = (
                rowData.nombreArchivo ||
                rowData.archivoUrl ||
                ''
            ).toLowerCase();

            // Corrección de tipos si el backend manda genérico
            if (!tipoArchivo || tipoArchivo === 'application/octet-stream') {
                if (nombreOriginal.endsWith('.pdf')) tipoArchivo = 'application/pdf';
                else if (nombreOriginal.match(/\.(jpg|jpeg|png|gif|webp)$/))
                    tipoArchivo = 'image/jpeg';
                else if (nombreOriginal.includes('.doc')) tipoArchivo = 'application/msword';
                else if (nombreOriginal.includes('.xls')) tipoArchivo = 'application/vnd.ms-excel';
            }

            const fileURL = URL.createObjectURL(blob);

            // --- CASO 1: IMÁGENES (Modal) ---
            if (tipoArchivo && tipoArchivo.startsWith('image/')) {
                setVisorContent(fileURL);
                setVisorType(tipoArchivo);
                setVisorTitle(rowData.descripcion || rowData.nombreArchivo || 'Visualización');
                setVisorVisible(true);
            }

            // --- CASO 2: PDF (Pestaña Nueva) ---
            else if (tipoArchivo === 'application/pdf') {
                // Intentamos abrir pestaña nueva
                const pdfWindow = window.open(fileURL, '_blank');

                // Si el navegador bloquea la pestaña o está configurado para descargar todo,
                // NO podemos cambiar el nombre del UUID aquí lamentablemente (limitación del navegador).
                // Pero si el usuario tiene configurado "Abrir PDFs", se verá bien.
                if (!pdfWindow) {
                    alert('Por favor habilite las ventanas emergentes para ver el PDF.');
                }
            }

            // --- CASO 3: OFFICE Y OTROS (Descarga con Nombre Correcto) ---
            else {
                // Aquí es donde arreglamos el problema del UUID para Words/Excel
                const link = document.createElement('a');
                link.href = fileURL;

                // Calculamos el nombre correcto
                let nombreFinal = rowData.nombreArchivo || `documento_${rowData.id}`;

                // Si falta la extensión, se la pegamos
                if (nombreFinal.indexOf('.') === -1) {
                    if (tipoArchivo.includes('word') || tipoArchivo.includes('officedocument'))
                        nombreFinal += '.docx';
                    else if (tipoArchivo.includes('sheet') || tipoArchivo.includes('excel'))
                        nombreFinal += '.xlsx';
                    else if (tipoArchivo.includes('pdf')) nombreFinal += '.pdf';
                    else nombreFinal += '.dat';
                }

                // ESTA LÍNEA ES LA QUE EVITA EL UUID:
                link.download = nombreFinal;

                link.click();
            }
        } catch (error) {
            console.error('Error visualizando documento:', error);
            alert('No se pudo cargar el documento.');
        }
    };

    const handleDescargarDocumento = async (rowData) => {
        try {
            // 1. Obtenemos el archivo (Blob)
            const blob = await visualizarDocumento(rowData.id);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // 2. Determinamos la extensión
            let extension = '';

            // A) Intentamos sacarla de la URL original si existe (ej: "foto.jpg")
            if (rowData.archivoUrl) {
                const partes = rowData.archivoUrl.split('.');
                if (partes.length > 1) {
                    extension = partes.pop().toLowerCase();
                    // Limpieza básica por si la URL tiene parámetros extra
                    if (extension.length > 4) extension = '';
                }
            }

            // B) Si no hay extensión en la URL, la sacamos del tipo de archivo (MIME Type)
            if (!extension) {
                if (blob.type === 'application/pdf') extension = 'pdf';
                else if (blob.type === 'image/jpeg') extension = 'jpg';
                else if (blob.type === 'image/png') extension = 'png';
                else if (blob.type.includes('word')) extension = 'docx';
                else if (blob.type.includes('sheet') || blob.type.includes('excel'))
                    extension = 'xlsx';
                else extension = 'dat'; // Binario genérico
            }

            // 3. Armamos el nombre final
            // Usamos 'nombreArchivo' si viene del backend, o generamos uno genérico con la extensión detectada
            let nombreFinal = rowData.nombreArchivo || `documento_${rowData.id}`;

            // Si el nombre no tiene punto, le pegamos la extensión que encontramos
            if (nombreFinal.indexOf('.') === -1 && extension) {
                nombreFinal = `${nombreFinal}.${extension}`;
            }

            link.setAttribute('download', nombreFinal);

            // 4. Descarga
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error al descargar:', error);
            // Puedes usar toast si lo prefieres: toast.current.show(...)
            alert('No se pudo descargar el archivo.');
        }
    };

    return (
        <>
            <Toast ref={xToast} />
            <DataTable
                value={lstDocumentos}
                tableStyle={{ minWidth: '40rem' }}
                size="small"
                showGridlines
                loading={cargaLic}
            >
                <Column header="Descripcion" field="descripcion"></Column>
                <Column header="Numero" field="referenciaDetalle"></Column>
                <Column header="Acciones" body={archivoBodyTemplate}></Column>
            </DataTable>
            <Dialog
                header={visorTitle}
                visible={visorVisible}
                style={{ width: '50vw', minWidth: '350px' }}
                modal
                onHide={hideVisor}
                maximizable
                dismissableMask
                contentStyle={{ padding: '0', textAlign: 'center', backgroundColor: '#333' }}
            >
                {visorContent ? (
                    <div
                        className="flex justify-content-center align-items-center"
                        style={{ minHeight: '400px' }}
                    >
                        {/* Nota: Si usas PDF, cambia 'img' por 'iframe' o 'object' */}
                        <img
                            src={visorContent}
                            alt="Documento"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '80vh',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                ) : (
                    <div className="flex align-items-center justify-content-center h-10rem text-white">
                        <i className="pi pi-spin pi-spinner text-4xl mr-2"></i> Cargando...
                    </div>
                )}
            </Dialog>
        </>
    );
};

export default VerArchivosGen;
